/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as AboutPageLoader } from './AboutPage/AboutPage.duck';
import { loadData as HowitWorkPageLoader } from './HowItWork/HowItWorkPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as SeoDiscoveryVenuePageLoader } from './SeoDiscoveryVenuePage/SeoDiscoveryVenuePage.duck';
import { loadData as SeoDiscoveryVenueSubpageLoader } from './SeoDiscoveryVenueSubpage/SeoDiscoveryVenueSubpage.duck';
import { loadData as SeoDiscoveryVenuesIndexPageLoader } from './SeoDiscoveryVenuesIndexPage/SeoDiscoveryVenuesIndexPage.duck';
import { loadData as SeoDiscoveryCitiesIndexPageLoader } from './SeoDiscoveryCitiesIndexPage/SeoDiscoveryCitiesIndexPage.duck';
import { loadData as SeoDiscoveryCitiesLetterPageLoader } from './SeoDiscoveryCitiesLetterPage/SeoDiscoveryCitiesLetterPage.duck';
import { loadData as SeoDiscoveryCityPageLoader } from './SeoDiscoveryCityPage/SeoDiscoveryCityPage.duck';
import { loadData as SeoDiscoveryCitySubpageLoader } from './SeoDiscoveryCitySubpage/SeoDiscoveryCitySubpage.duck';
import { loadData as SeoDiscoveryPerformersIndexPageLoader } from './SeoDiscoveryPerformersIndexPage/SeoDiscoveryPerformersIndexPage.duck';
import { loadData as SeoDiscoveryPerformersLetterPageLoader } from './SeoDiscoveryPerformersLetterPage/SeoDiscoveryPerformersLetterPage.duck';
import { loadData as SeoDiscoveryPerformerPageLoader } from './SeoDiscoveryPerformerPage/SeoDiscoveryPerformerPage.duck';
import { loadData as SeoDiscoveryPerformerSubpageLoader } from './SeoDiscoveryPerformerSubpage/SeoDiscoveryPerformerSubpage.duck';
import { loadData as SeoDiscoveryVenuesLetterPageLoader } from './SeoDiscoveryVenuesLetterPage/SeoDiscoveryVenuesLetterPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    AboutPage: {
      loadData: AboutPageLoader,
    },
    HowitWorkPage: {
      loadData: HowitWorkPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    SeoCitiesIndexPage: {
      loadData: SeoDiscoveryCitiesIndexPageLoader,
    },
    SeoCitiesLetterPage: {
      loadData: SeoDiscoveryCitiesLetterPageLoader,
    },
    SeoCityPage: {
      loadData: SeoDiscoveryCityPageLoader,
    },
    SeoCitySubpage: {
      loadData: SeoDiscoveryCitySubpageLoader,
    },
    SeoPerformersIndexPage: {
      loadData: SeoDiscoveryPerformersIndexPageLoader,
    },
    SeoPerformersLetterPage: {
      loadData: SeoDiscoveryPerformersLetterPageLoader,
    },
    SeoPerformerPage: {
      loadData: SeoDiscoveryPerformerPageLoader,
    },
    SeoPerformerSubpage: {
      loadData: SeoDiscoveryPerformerSubpageLoader,
    },
    SeoVenuesLetterPage: {
      loadData: SeoDiscoveryVenuesLetterPageLoader,
    },
    SeoVenuesIndexPage: {
      loadData: SeoDiscoveryVenuesIndexPageLoader,
    },
    SeoVenuePage: {
      loadData: SeoDiscoveryVenuePageLoader,
    },
    SeoVenueSubpage: {
      loadData: SeoDiscoveryVenueSubpageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
